export class Settings {
    static apiKey = () => {
        return import.meta.env.VITE_MAPTILER_KEY;
    };

    static baseApiUrl = () => {
        return import.meta.env.VITE_API_URL;
    };

    static getApiUrl = (subUrl) => {
        return (
            Settings.baseApiUrl().replace(/\/+$/, '') +
            '/' +
            subUrl.replace(/^\/+/, '')
        );
    };

    static showTracker = () => {
        return import.meta.env.VITE_SHOW_TRACKER.toLowerCase() === 'true';
    };

    static popupOnClick() {
        return import.meta.env.VITE_POPUP_ON_CLICK.toLowerCase() === 'true';
    }
}
